// extracted by mini-css-extract-plugin
export var alignCenter = "_7y-d";
export var bannerShown = "_7y-6";
export var buttonContent = "_7y-0";
export var cardList = "_7y-1";
export var centerContent = "_7y-2";
export var chevron = "_7y-3";
export var closePanelButton = "_7y-k";
export var conversationContextContainer = "_7y-l";
export var conversationDetailContainer = "_7y-4";
export var detailWrapper = "_7y-7";
export var dropdownButton = "_7y-e";
export var dropdownTitle = "_7y-9";
export var fullHeight = "_7y-5";
export var hidden = "_7y-a";
export var icon = "_7y-b";
export var mergeSuggestionWrapper = "_7y-m";
export var panel = "_7y-i";
export var portalButtonsWrapper = "_7y-c";
export var right = "_7y-j";
export var tableSummaryContainer = "_7y-8";
export var tableSummaryHeader = "_7y-g";
export var threeDotsButton = "_7y-f";
export var wide = "_7y-h";